import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpInterceptorService, RESTService } from '@covalent/http';
import { MOCK_API } from '../config/api.config';
import { Observable } from 'rxjs/Observable';
import { environment } from '../environments/environment';
import 'rxjs/add/operator/map';
@Injectable()
export class ResumenPacienteService extends RESTService<any> {

  constructor(private _http: HttpInterceptorService) {
    super(_http, {
      baseUrl: MOCK_API,
      path: '/resumenPaciente',
    });
  }

  obtenerResumenPaciente(idPaciente: string, numeroVisita: string): any {
    return this._http.post(environment.api_host + 'resumenPaciente/obtenerResumenPaciente', {idPaciente: idPaciente, Num_visita: numeroVisita})
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

}



// WEBPACK FOOTER //
// ./src/services/resumenpaciente.service.ts